.orbs {
    position: relative;
    background-color: white;
}

.content {
    position: relative;
    z-index: 1;
}

.orb {
    pointer-events: none;
    background-color: var(--background-color);
    position: absolute;
    width: 400px;
    height: 400px;
    filter: blur(200px);
    border-radius: 50%;
    animation: noisyFloat 32s ease-in-out infinite;
    animation-delay: var(--noise-offset);
    --noise-magnitude: 50%;
}

@keyframes noisyFloat {
    0% {
        transform: translate(0, 0);
        opacity: 0.8;
    }
    12.5% {
        transform: translate(
            calc(var(--noise-magnitude) * 0.67),
            calc(var(--noise-magnitude) * -0.2)
        );
        opacity: 0.6;
    }
    25% {
        transform: translate(
            calc(var(--noise-magnitude) * -0.33),
            calc(var(--noise-magnitude) * -0.1)
        );
        opacity: 0.4;
    }
    37.5% {
        transform: translate(calc(var(--noise-magnitude) * -1), calc(var(--noise-magnitude) * 0));
        opacity: 0.6;
    }
    50% {
        transform: translate(
            calc(var(--noise-magnitude) * -0.53),
            calc(var(--noise-magnitude) * 0.2)
        );
        opacity: 0.8;
    }
    62.5% {
        transform: translate(
            calc(var(--noise-magnitude) * 0.2),
            calc(var(--noise-magnitude) * 0.1)
        );
        opacity: 0.6;
    }
    75% {
        transform: translate(calc(var(--noise-magnitude) * 1), calc(var(--noise-magnitude) * -0.1));
        opacity: 0.4;
    }
    87.5% {
        transform: translate(
            calc(var(--noise-magnitude) * 0.53),
            calc(var(--noise-magnitude) * 0.1)
        );
        opacity: 0.6;
    }
    100% {
        transform: translate(0, 0);
        opacity: 0.8;
    }
}
